import { render } from "./mainIndex.vue?vue&type=template&id=5eb08fb6"
import script from "./mainIndex.vue?vue&type=script&lang=js"
export * from "./mainIndex.vue?vue&type=script&lang=js"
script.render = render

export default script